import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  paper: {
    // width: theme.spacing(112.5),
    borderRadius: theme.spacing(0.5),
    boxShadow:
      "0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px -7px rgba(0, 0, 0, 0.20)",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    width: theme.spacing(112.5),
    // height: theme.spacing(54),
  },
  companyHeading: {
    padding: "16px 24px",
    width: "100%",
    "&  p": {
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "32px",
      letterSpacing: "0.15px",
    },
  },

  formWrapper: {
    display: "flex",
    flexFlow: "column",
    justifyContent: "flex-end",
    padding: "0px 24px 20px 24px",
    alignSelf: "stretch",
    "& .MuiInput-root, & .MuiInputBase-root": {
      height: theme.spacing(7),
    },
  },
  gridWrapper: {
    gap: theme.spacing(3),
    display: "grid",
    "& > div:first-child": {
      marginTop: "16px",
    },
    '& fieldset, .MuiInput-root':{
      borderColor:'rgba(0, 0, 0, 0.23) !important',
    },
  },
  switchControlWrapper: {
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    border: "1px solid  rgba(0, 0, 0, 0.23)",
    height: theme.spacing(7),
    "&  > p": {
      padding: `8px 16px`,
      flex: 1,
    },
  },
  sectionWrapper: {
    gap: theme.spacing(3),
    display: "grid",
    "& > div": {
      display: "flex",
      gap: theme.spacing(3),
      "& > div": {
        flex: 1,
        '& [class^="makeStyles-spacing__container-"]':{
          display:'none'
        },
      },
    },
  },
  actionSection: {
    width: "100%",
  },
  cancel: { marginRight: theme.spacing(1) },
  errorStyle:{
    fontSize: "12px",
    bottom: '-0.9rem',
    color:'red'
  },
  setDivWidth: {
    "& .MuiInputBase-root": {
    width: "49%"
    }
  },
  tooltipIconWrapper: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
    flex: "1 0 0",
    padding: "4px 0px",
  },
}));
